import { Provider } from "react-redux";
import CompletedTodos from "./components/CompletedTodos";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <Navbar />
      <div className='grid place-items-center bg-blue-100  space-y-6 px-4 py-8 font-sans overflow-y-auto'>
        <div className='w-full max-w-3xl shadow-lg rounded-lg p-6 mx-4 bg-white'>
          <Header />

          <hr className='mt-4' />

          <TodoList completed={false} />

          <hr className='mt-4' />

          <Footer />
        </div>
        <div className='w-full max-w-3xl shadow-lg rounded-lg p-6 mx-4 bg-white mb-8'>
          <CompletedTodos />
        </div>
      </div>
    </Provider>
  );
}

export default App;
